import VideoGallery from '../../__page/videoGallery';

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        VideoGallery.init();
    },
    loaded() {},
    resized() {},
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
